import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=bb2f486c&scoped=true&"
import script from "./pay.js?vue&type=script&lang=js&"
export * from "./pay.js?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=bb2f486c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2f486c",
  null
  
)

export default component.exports